import * as React from "react"
import { cn } from "@lib/cn"

export interface EmptyStateProps extends Omit<React.HTMLAttributes<HTMLDivElement>, "title"> {
  icon?: React.ReactNode
  title: React.ReactNode
  description?: React.ReactNode
  action?: React.ReactNode
  size?: "sm" | "md" | "lg"
}

export const EmptyState = React.forwardRef<HTMLDivElement, EmptyStateProps>(
  ({ className, icon, title, description, action, size = "md", ...props }, ref) => {
    const pad = size === "sm" ? "py-8" : size === "lg" ? "py-20" : "py-14"
    return (
      <div
        ref={ref}
        className={cn("flex flex-col items-center justify-center text-center", pad, className)}
        {...props}
      >
        {icon && (
          <div
            className={cn(
              "mb-3 flex items-center justify-center rounded-pill bg-cloverhound-gray-100 text-cloverhound-gray-600 dark:bg-cloverhound-gray-850 dark:text-cloverhound-gray-400",
              size === "sm" ? "size-8 [&>*]:size-4" : size === "lg" ? "size-14 [&>*]:size-7" : "size-12 [&>*]:size-6",
            )}
            aria-hidden="true"
          >
            {icon}
          </div>
        )}
        <h3
          className={cn(
            "font-semibold text-cloverhound-gray-900 dark:text-cloverhound-gray-50",
            size === "sm" ? "text-small" : size === "lg" ? "text-large" : "text-regular",
          )}
        >
          {title}
        </h3>
        {description && (
          <p className="mt-1 max-w-sm text-small text-cloverhound-gray-700 dark:text-cloverhound-gray-400">{description}</p>
        )}
        {action && <div className="mt-4">{action}</div>}
      </div>
    )
  },
)
EmptyState.displayName = "EmptyState"
